const metaOgObject = {
  ru: {
    homePage: {
      title: "Онлайн-касса Flyashgabat",
      type: "website",
      url: "https://flyashgabat.com/",
      image: "https://flyashgabat.com/images/background.png",
      description:
        "Наша удобная платформа делает бронирование авиабилетов простым делом. Найдите идеальный маршрут, получите предложение cashback и завершите покупку за считанные минуты.",
      site_name: "Flyashgabat",
    },
    cashbackPage: {
      title: "Акции - Кэшбэк Flyashgabat",
      type: "website",
      url: "https://flyashgabat.com/cashback-info",
      image: "https://flyashgabat.com/images/seo/cashback.jpg",
      description:
        "Надоело просто копить мили, которые вы, возможно, никогда не используете? Зарабатывайте реальные деньги на каждом рейсе, который вы бронируете у нас.",
      site_name: "Flyashgabat Кэшбэк",
    },
  },
  en: {
    homePage: {
      title: "Online ticketing Flyashgabat",
      type: "website",
      url: "https://flyashgabat.com/",
      image: "https://flyashgabat.com/images/background.png",
      description:
        "Our user-friendly platform makes booking flights a breeze. Find the perfect itinerary, secure your cashback offer, and complete your purchase in minutes.",
      site_name: "Flyashgabat",
    },
    cashbackPage: {
      title: "Deals - Cashback Flyashgabat",
      type: "website",
      url: "https://flyashgabat.com/cashback-info",
      image: "https://flyashgabat.com/images/seo/cashback.jpg",
      description:
        "Tired of just racking up miles you might never use? Earn real cash back on every flight you book with us.",
      site_name: "Flyashgabat Cashback",
    },
  },
  uz: {
    homePage: {
      title: "Onlayn-kassa Flyashgabat",
      type: "website",
      url: "https://flyashgabat.com/",
      image: "https://flyashgabat.com/images/background.png",
      description:
        "Bizning qulay platformamiz parvozlarni bron qilishni osonlashtiradi. Ideal marshrutingizni toping, cashback taklifini oling va xaridingizni bir necha daqiqada yakunlang.",
      site_name: "Flyashgabat",
    },
    cashbackPage: {
      title: "Aksiyalar - Cashback Flyashgabat",
      type: "website",
      url: "https://flyashgabat.com/cashback-info",
      image: "https://flyashgabat.com/images/seo/cashback.jpg",
      description:
        "Hech qachon foydalana olmaydigan millarni yig'ishdan charchadingizmi? Biz bilan bron qilgan har bir reysda haqiqiy pul ishlang.",
      site_name: "Flyashgabat Cashback",
    },
  },
};

export default metaOgObject;